module.exports = __webpack_public_path__ + "assets/img/m_bdt_img4.880d46ed.png";